import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Navbar";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useSeo } from "../lib/seo";

export default function Register() {
    const { register } = useAuth();
    const navigate = useNavigate();
    useSeo({ title: "Create your free account", description: "Create a free Sift account, upload a bank statement and find out where your money went. No card, no bank login.", path: "/register" });
    const [form, setForm] = useState({ name: "", email: "", password: "" });
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await register(form);
        setLoading(false);
        if (res.ok) { toast.success("Welcome to Sift"); navigate("/upload"); } else toast.error(res.error);
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-background px-4 py-12" data-testid="register-page">
            <div className="w-full max-w-md">
                <div className="mb-8 flex justify-center"><Logo /></div>
                <div className="rounded-2xl border border-border bg-card p-8 shadow-2xl">
                    <h1 className="font-heading text-2xl font-bold text-foreground">Create your account</h1>
                    <p className="mt-1 text-sm text-muted-foreground">Free to start. <span className="font-semibold text-primary" data-testid="register-free-note">No card, no bank login — just a statement.</span></p>
                    <form onSubmit={submit} className="mt-6 space-y-4">
                        <div>
                            <Label htmlFor="name" className="text-foreground/85">Name</Label>
                            <Input id="name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name-input" className="mt-1.5 bg-secondary border-border" placeholder="Sam" />
                        </div>
                        <div>
                            <Label htmlFor="email" className="text-foreground/85">Email</Label>
                            <Input id="email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email-input" className="mt-1.5 bg-secondary border-border" placeholder="you@example.com" />
                        </div>
                        <div>
                            <Label htmlFor="password" className="text-foreground/85">Password</Label>
                            <Input id="password" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password-input" className="mt-1.5 bg-secondary border-border" placeholder="At least 6 characters" />
                        </div>
                        <Button type="submit" disabled={loading} data-testid="register-submit-btn" className="w-full bg-primary font-semibold text-primary-foreground hover:bg-primary/90">
                            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Create account"}
                        </Button>
                    </form>
                    <p className="mt-6 text-center text-sm text-muted-foreground">
                        Already have an account? <Link to="/login" className="font-semibold text-primary hover:underline" data-testid="to-login-link">Sign in</Link>
                    </p>
                </div>
            </div>
        </div>
    );
}
